import { Col, Form, Input, InputNumber, Row, Select } from "antd";
import { memo, useEffect } from "react";
import { useIntl } from "react-intl";

import countryCodes from "../../config/countryCodes";
import timeZones from "../../config/timeZones";

const STATUS = ["ACTIVE", "INACTIVE", "PENDING"];

const AddAndEditVenueForm = (props) => {
  const { handleSetFormRef, siteList, venue } = props;
  const { formatMessage } = useIntl();
  const [form] = Form.useForm();
  const initValues = {
    ...venue,
  };

  useEffect(() => {
    handleSetFormRef(form);
  }, []);

  return (
    <Form
      form={form}
      labelCol={{
        span: 10,
      }}
      colon={false}
      labelWrap={true}
      initialValues={initValues}
    >
      <Col span={24}>
        <Row>
          <Col span={12}>
            <Form.Item
              labelCol={{
                span: 9,
              }}
              required={true}
              name={"nameLocal"}
              label={formatMessage({
                id: "name.local",
              })}
              tooltip={formatMessage(
                {
                  id: "form.help.local.name.item",
                },
                {
                  item: formatMessage({
                    id: "venue",
                  }),
                },
              )}
              rules={[
                {
                  required: true,
                  message: "Local Name Is Required",
                },
                {
                  maxLength: 150,
                  message: "Max 150 characters",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              labelCol={{
                span: 11,
              }}
              name={"abbreviationLocal"}
              label={formatMessage({
                id: "name.local.abbreviation",
              })}
              tooltip={formatMessage({ id: "form.help.local.abbreviation" })}
              rules={[
                {
                  maxLength: 50,
                  message: formatMessage({ id: "error.max.input.length" }),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item
              labelCol={{
                span: 9,
              }}
              name={"nameLatin"}
              label={formatMessage({ id: "name.latin" })}
              tooltip={formatMessage(
                {
                  id: "form.help.latin.name.item",
                },
                {
                  item: formatMessage({
                    id: "venue",
                  }),
                },
              )}
              rules={[
                {
                  maxLength: 150,
                  message: "Max 150 characters",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              labelCol={{
                span: 10,
              }}
              name={"abbreviationLatin"}
              label={formatMessage({
                id: "name.latin.abbreviation",
              })}
              tooltip={formatMessage({
                id: "form.help.latin.abbreviation",
              })}
              rules={[
                {
                  maxLength: 50,
                  message: formatMessage({ id: "error.max.input.length" }),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item
              labelCol={{
                span: 9,
              }}
              name={"timezone"}
              label={formatMessage({
                id: "timezone",
              })}
              tooltip={formatMessage(
                {
                  id: "form.help.timezone.of.the.item",
                },
                {
                  item: formatMessage({
                    id: "venue",
                  }),
                },
              )}
              required={true}
              rules={[
                {
                  required: true,
                  message: "Time Zone is required",
                },
              ]}
            >
              <Select showSearch>
                {timeZones?.map((timeZone) => (
                  <Select.Option key={timeZone} value={timeZone}>
                    {timeZone}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              labelCol={{
                span: 6,
              }}
              name={"siteId"}
              label={formatMessage({
                id: "site",
              })}
              tooltip={formatMessage({
                id: "form.help.venue.site",
              })}
            >
              <Select showSearch>
                {siteList?.map((site) => (
                  <Select.Option value={site.siteId} key={site.siteId}>
                    {site.nameLocal}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item
              name={"status"}
              label={formatMessage({
                id: "status",
              })}
              tooltip={formatMessage(
                {
                  id: "form.help.status.item",
                },
                {
                  item: formatMessage({
                    id: "venue",
                  }),
                },
              )}
              required
              rules={[
                {
                  required: true,
                  message: "Status Is Required",
                },
              ]}
            >
              <Select>
                {STATUS?.map((status) => (
                  <Select.Option value={status} key={status}>
                    {status}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              labelCol={{
                span: 8,
              }}
              name={"countryCode"}
              label={formatMessage({
                id: "country",
              })}
              tooltip={formatMessage(
                {
                  id: "form.help.country.of.the.item",
                },
                {
                  item: formatMessage({
                    id: "venue",
                  }),
                },
              )}
            >
              <Select showSearch>
                {countryCodes?.map((countryCode) => (
                  <Select.Option key={countryCode[0]} value={countryCode[0]}>
                    {countryCode[1]}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item
              labelCol={{
                span: 10,
              }}
              name={["address", "city"]}
              label={formatMessage({
                id: "city",
              })}
              tooltip={formatMessage({
                id: "form.help.venue.city",
              })}
              rules={[
                {
                  maxLength: 50,
                  message: formatMessage({ id: "error.max.input.length" }),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              labelCol={{
                span: 10,
              }}
              name={["address", "state"]}
              label={formatMessage({
                id: "state",
              })}
              tooltip={formatMessage({
                id: "form.help.venue.state",
              })}
              rules={[
                {
                  maxLength: 50,
                  message: formatMessage({ id: "error.max.input.length" }),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item
              labelCol={{
                span: 10,
              }}
              name={["address", "postalCode"]}
              label={formatMessage({
                id: "postalCode",
              })}
              tooltip={formatMessage({
                id: "form.help.venue.postalCode",
              })}
              rules={[
                {
                  maxLength: 50,
                  message: formatMessage({ id: "error.max.input.length" }),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              labelCol={{
                span: 10,
              }}
              name={["address", "address1"]}
              label={formatMessage({
                id: "address1",
              })}
              tooltip={formatMessage({
                id: "form.help.venue.address1",
              })}
              rules={[
                {
                  maxLength: 50,
                  message: formatMessage({ id: "error.max.input.length" }),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item
              labelCol={{
                span: 10,
              }}
              name={["address", "address2"]}
              label={formatMessage({
                id: "address2",
              })}
              tooltip={formatMessage({
                id: "form.help.venue.address2",
              })}
              rules={[
                {
                  maxLength: 50,
                  message: formatMessage({ id: "error.max.input.length" }),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              labelCol={{
                span: 10,
              }}
              name={["address", "address3"]}
              label={formatMessage({
                id: "address3",
              })}
              tooltip={formatMessage({
                id: "form.help.venue.address3",
              })}
              rules={[
                {
                  maxLength: 50,
                  message: formatMessage({ id: "error.max.input.length" }),
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item
              labelCol={{
                span: 10,
              }}
              name={"capacity"}
              label={formatMessage({
                id: "capacity",
              })}
              tooltip={formatMessage({
                id: "form.help.venue.capacity",
              })}
            >
              <InputNumber min={0} />
            </Form.Item>
          </Col>
        </Row>
      </Col>
    </Form>
  );
};

export default memo(AddAndEditVenueForm);
